export const getHeaders = (
  payrollType,
  employmentType,
  additionalSelectValue,
  otherDeduction,
  csvData,
  incentives = [],
  contributionType
) => {
  console.log("otherDeduction", otherDeduction);
  const allowanceName = incentives.length ? incentives[0].allowanceType : "";
  const allowanceTypes = incentives.map((item) => item.otherAllowances).flat();
  const otherAdditional = incentives.map((item) => item.otherAdditional).flat();

  const displayHeaderLabel = allowanceTypes.map((allowance) => ({
    label: allowance,
  }));

  const additionalHeader = otherAdditional.map((allowance) => ({
    label: allowance,
  }));

  const otherDeductionType = otherDeduction
    .reduce((acc, item) => {
      if (
        item.deductionType === "Other Deduction" &&
        item.payrollType === payrollType &&
        item.employmentName === employmentType &&
        item.employmentType === additionalSelectValue
      ) {
        acc.push(item.otherDeduction);
      }
      return acc;
    }, [])
    .flat();

  const contributions = contributionType
    .reduce((acc, item) => {
      acc.push(item.contributionType);
      return acc;
    }, [])
    .flat();

  const otherAdditionalType = otherDeduction
    .reduce((acc, item) => {
      if (
        item.deductionType === "Other Additional" &&
        item.payrollType === payrollType &&
        item.employmentName === employmentType &&
        item.employmentType === additionalSelectValue
      ) {
        acc.push(item.otherDeduction);
      }
      return acc;
    }, [])
    .flat();

  const otherDeductionColSpan = otherDeductionType.length;
  const otherAdditionalColSpan = otherAdditionalType.length;
  const contributionColSpan = contributions.length;

  const jobOrderBasicPayHeaders = [
    { rowSpan: 2, label: "#" },
    // { rowSpan: 2, label: "NO. OF DAYS" },
    // { rowSpan: 2, label: "DAYS TO BE DEDUCTED" },
    // { rowSpan: 2, label: "MINS TO BE DEDUCTED" },
    { rowSpan: 2, label: "EMPLOTYEE NUMBER" },
    { rowSpan: 2, label: "ACCT NO." },
    { rowSpan: 2, label: "LN" },
    { rowSpan: 2, label: "FN" },
    { rowSpan: 2, label: "MN" },
    { rowSpan: 2, label: "BASIC" },
    { colSpan: 4, label: "DEDUCTIONS BEFORE TAX" },
    { rowSpan: 2, label: "EARNED FOR THE PERIOD" },
    { colSpan: 5, label: "WITHHOLDING TAX" },
    ...(otherDeductionType.length > 0
      ? [
          {
            colSpan: otherDeductionColSpan,
            label: "OTHER DEDUCTIONS",
          },
        ]
      : []),
    ...(otherAdditionalType.length > 0
      ? [{ colSpan: otherAdditionalColSpan, label: "OTHER ADDITIONAL" }]
      : []),
    { rowSpan: 2, label: "NET PAY" },
    { rowSpan: 2, label: "EMAIL" },
  ];

  const jobOrderBasicPaySubHeaders = [
    "ABSENCES (DAYS)",
    "ABSENCES (MINS)",
    "OVERPAYMENT",
    "FLAG RAISING",
    "3%",
    "2%",
    "5%",
    "10%",
    "TOTAL TAX",
  ];

  const augmentedPayHeaders = [
    { rowSpan: 2, label: "#" },
    { colSpan: 4, label: "PRESENT ASSIGNMENT" },
    { colSpan: 3, label: "AUGMENTATION(T1, T3, CIA, MCIA, & DIA)" },
    { rowSpan: 2, label: "EMPLOYEE NUMBER" },
    { rowSpan: 2, label: "ACCT NUMBER" },
    { rowSpan: 2, label: "LN" },
    { rowSpan: 2, label: "FN" },
    { rowSpan: 2, label: "MN" },
    { rowSpan: 2, label: "AP RATE" },
    { colSpan: 5, label: "CURRENT ASSIGNMENT" },
    { colSpan: 5, label: "AIRPORT AUGMENTATION" },
    { rowSpan: 2, label: "EXCESS AIRPORT DUTIES" },
    { rowSpan: 2, label: "TOTAL EARNED" },
    { colSpan: 2, label: "DEDUCTIONS BEFORE TAX" },
    { rowSpan: 2, label: "NET EARNED" },
    ...(contributions.length > 0
      ? [{ colSpan: contributionColSpan + 1, label: "MANDATORY DEDUCTIONS" }]
      : []),
    ...(otherDeductionType.length > 0
      ? [
          {
            colSpan: otherDeductionColSpan,
            label: "LOANS AND OTHER DEDUCTIONS",
          },
        ]
      : []),
    ...(otherAdditionalType.length > 0
      ? [{ colSpan: otherAdditionalColSpan, label: "OTHER ADDITIONAL" }]
      : []),
    { rowSpan: 2, label: "NET AMOUNT" },
    { rowSpan: 2, label: "Email" },
  ];

  const augmentedPaySubHeaders = [
    "Y=24/7 N=7:00-5:30",
    "# of duty for CIA/MCIA/BINOC (Range to 15-19) Manual Input",
    "ABS",
    "LATES/ UT per minute",
    "NO.OF DUTIES",
    "ABS",
    "LATES/UT per minute",
    "TOTAL DAYS DUTY",
    "PRORATED AP RATE",
    "ABSENCES/LEAVES",
    "LATES/ UT per minute",
    "EARNED CURRENT ASSIGNMENT",
    "AIRPORT AUGMENTATION RATE",
    "AMOUNT EARNED AIRPORT AUGMENTATION",
    "ABSENCES/LEAVES",
    "LATES/ UT per minute",
    "EARNED AIRPORT DUTIES",
    "OVERPAYMENT",
    "FLAG RAISING",
    "Tax",
    ...contributions,
  ];

  const backPayHeaders = [
    { rowSpan: 2, label: "#" },
    { rowSpan: 2, label: "DAYS IN A MONTH" },
    { rowSpan: 2, label: "GISI INSURED DAYS" },
    { rowSpan: 2, label: "DAYS TO BE DEDUCTED" },
    { rowSpan: 2, label: "HALF DAYS TO BE DEDUCTED" },
    { rowSpan: 2, label: "MINUTES TO BE DEDUCTED" },
    { colSpan: 2, label: "PERIOD COVERED" },
    { rowSpan: 2, label: "EMPLOTYEE NUMBER" },
    { rowSpan: 2, label: "ACCT NO." },
    { rowSpan: 2, label: "LN" },
    { rowSpan: 2, label: "FN" },
    { rowSpan: 2, label: "MN" },
    { rowSpan: 2, label: "BASIC" },
    { rowSpan: 2, label: "PERA/ADA" },
    { colSpan: 4, label: "DEDUCTIONS BEFORE TAX" },
    { rowSpan: 2, label: "EARNED (BASIC)" },
    { rowSpan: 2, label: "EARNED (PERA ADA)" },
    ...(contributions.length > 0
      ? [{ colSpan: contributionColSpan + 1, label: "MANDATORY DEDUCTIONS" }]
      : []),
    ...(otherDeductionType.length > 0
      ? [
          {
            colSpan: otherDeductionColSpan,
            label: "OTHER DEDUCTIONS",
          },
        ]
      : []),
    ...(otherAdditionalType.length > 0
      ? [{ colSpan: otherAdditionalColSpan, label: "OTHER ADDITIONAL" }]
      : []),
    { rowSpan: 2, label: "NET PAY" },
    { rowSpan: 2, label: "EMAIL" },
  ];

  const backPaySubHeaders = [
    "MONTH",
    "YEAR",
    "DEDUCTIONS DUE TO LEAVES, ABSENCES AND TARDINESS(BASIC)",
    "DEDUCTION(PERA/ADA)",
    "OVERPAYMENT(BASIC)",
    "OVERPAYMENT(PERA ADA)",
    "Tax",
    ...contributions,
  ];

  const basicPayHeaders = [
    { rowSpan: 2, label: "#" },
    { rowSpan: 2, label: "EMPLOYEE NUMBER" },
    { rowSpan: 2, label: "ACCT NO." },
    { rowSpan: 2, label: "LN" },
    { rowSpan: 2, label: "FN" },
    { rowSpan: 2, label: "MN" },
    { rowSpan: 2, label: "BASIC" },
    { rowSpan: 2, label: "PERA" },
    { rowSpan: 2, label: "OVERPAYMENT (BASIC)" },
    { rowSpan: 2, label: "OVERPAYMENT (PERA ADA)" },
    { rowSpan: 2, label: "EARNED (BASIC)" },
    { rowSpan: 2, label: "EARNED (PERA ADA)" },
    ...(contributions.length > 0
      ? [{ colSpan: contributionColSpan + 1, label: "MANDATORY DEDUCTIONS" }]
      : []),
    ...(otherDeductionType.length > 0
      ? [
          {
            colSpan: otherDeductionColSpan,
            label: "LOANS AND OTHER DEDUCTIONS",
          },
        ]
      : []),
    ...(otherAdditionalType.length > 0
      ? [{ colSpan: otherAdditionalColSpan, label: "OTHER ADDITIONAL" }]
      : []),
    { rowSpan: 2, label: "NET AMOUNT" },
    { rowSpan: 2, label: "Email" },
  ];

  const basicPaySubHeaders = ["Tax", ...contributions];

  const AddendumPayHeaders = [
    { rowSpan: 2, label: "#" },
    { rowSpan: 2, label: "EMPLOYEE NUMBER" },
    { rowSpan: 2, label: "ACCT NO." },
    { rowSpan: 2, label: "LN" },
    { rowSpan: 2, label: "FN" },
    { rowSpan: 2, label: "MN" },
    { rowSpan: 2, label: "BASIC" },
    { rowSpan: 2, label: "PERA" },
    { rowSpan: 2, label: "DATE OF ABSENCES" },
    { rowSpan: 2, label: "LEAVE WITHOUT PAY DATES" },
    { rowSpan: 2, label: "DATE OF HALF DAYS" },
    { rowSpan: 2, label: "DAYS TO BE DEDUCTED" },
    { rowSpan: 2, label: "HALF DAYS TO BE DEDUCTED" },
    { rowSpan: 2, label: "MINUTES TO BE DEDUCTED" },
    { rowSpan: 2, label: "GSIS INSURED DAYS" },
    { colSpan: 4, label: "DEDUCTIONS BEFORE TAX" },
    { rowSpan: 2, label: "EARNED (BASIC)" },
    { rowSpan: 2, label: "EARNED (PERA ADA)" },
    ...(contributions.length > 0
      ? [{ colSpan: contributionColSpan + 1, label: "MANDATORY DEDUCTIONS" }]
      : []),
    ...(otherDeductionType.length > 0
      ? [
          {
            colSpan: otherDeductionColSpan,
            label: "LOANS AND OTHER DEDUCTIONS",
          },
        ]
      : []),
    ...(otherAdditionalType.length > 0
      ? [{ colSpan: otherAdditionalColSpan, label: "OTHER ADDITIONAL" }]
      : []),
    { rowSpan: 2, label: "NET PAY" },
    { rowSpan: 2, label: "Email" },
  ];

  const AddendumPaySubHeaders = [
    "DEDUCTIONS DUE TO LEAVES, ABSENCES AND TARDINESS(BASIC)",
    "DEDUCTION (PERA/ADA)",
    "OVERPAYMENT (BASIC)",
    "OVERPAYMENT (PERA ADA)",
    "Tax",
    ...contributions,
  ];

  const AddendumPayJOHeaders = [
    { rowSpan: 2, label: "#" },
    { rowSpan: 2, label: "EMPLOYEE NUMBER" },
    { rowSpan: 2, label: "ACCT NO." },
    { rowSpan: 2, label: "LN" },
    { rowSpan: 2, label: "FN" },
    { rowSpan: 2, label: "MN" },
    { rowSpan: 2, label: "BASIC" },
    { rowSpan: 2, label: "DAYS TO BE DEDUCTED" },
    { rowSpan: 2, label: "MINS TO BE DEDUCTED" },
    { colSpan: 5, label: "DEDUCTIONS BEFORE TAX" },
    { colSpan: 5, label: "WITHHOLDING TAX" },
    ...(otherDeductionType.length > 0
      ? [
          {
            colSpan: otherDeductionColSpan,
            label: "OTHER DEDUCTIONS",
          },
        ]
      : []),
    { rowSpan: 2, label: "NET PAY" },
    { rowSpan: 2, label: "Email" },
  ];

  const AddendumPayJOSubHeaders = [
    "ABSENCES DAYS",
    "ABSENCES MINS",
    "OVERPAYMENT",
    "FLAG RAISING",
    "EARNED FOR THE PERIOD",
    "3%",
    "2%",
    "5%",
    "10%",
    "TOTAL TAX",
  ];

  const AddToAddHeaders = [
    { rowSpan: 2, label: "#" },
    { rowSpan: 2, label: "EMPLOYEE NUMBER" },
    { rowSpan: 2, label: "ACCT NO." },
    { rowSpan: 2, label: "LN" },
    { rowSpan: 2, label: "FN" },
    { rowSpan: 2, label: "MN" },
    { rowSpan: 2, label: "BASIC" },
    { rowSpan: 2, label: "PERA" },
    { rowSpan: 2, label: "DAYS IN A MONTH" },
    { rowSpan: 2, label: "GSIS INSURED DAYS" },
    { rowSpan: 2, label: "DAYS TO BE DEDUCTED" },
    { rowSpan: 2, label: "HALF DAYS TO BE DEDUCTED" },
    { rowSpan: 2, label: "MINUTES TO BE DEDUCTED" },
    { colSpan: 4, label: "DEDUCTIONS BEFORE TAX" },
    { rowSpan: 2, label: "EARNED (BASIC)" },
    { rowSpan: 2, label: "EARNED (PERA ADA)" },
    ...(contributions.length > 0
      ? [{ colSpan: contributionColSpan + 1, label: "MANDATORY DEDUCTIONS" }]
      : []),
    ...(otherDeductionType.length > 0
      ? [
          {
            colSpan: otherDeductionColSpan,
            label: "OTHER DEDUCTIONS",
          },
        ]
      : []),
    ...(otherAdditionalType.length > 0
      ? [{ colSpan: otherAdditionalColSpan, label: "OTHER ADDITIONAL" }]
      : []),
    { rowSpan: 2, label: "NET PAY" },
    { rowSpan: 2, label: "Email" },
  ];

  const AddToAddSubHeaders = [
    "DEDUCTIONS DUE TO LEAVES, ABSENCES AND TARDINESS(BASIC)",
    "DEDUCTION (PERA/ADA)",
    "OVERPAYMENT (BASIC)",
    "OVERPAYMENT (PERA ADA)",
    "Tax",
    ...contributions,
  ];

  const headersISB = [
    { rowSpan: 2, label: "#" },
    { rowSpan: 2, label: "EMPLOYMENT STATUS" },
    { rowSpan: 2, label: "NH STATUS" },
    { rowSpan: 2, label: "CONCAT LIST" },
    { rowSpan: 2, label: "EMPLOYEE CODE" },
    { rowSpan: 2, label: "ACCOUNT NUMBER" },
    { rowSpan: 2, label: "LN" },
    { rowSpan: 2, label: "FN" },
    { rowSpan: 2, label: "MN" },
    { rowSpan: 2, label: "COVERAGE PERIOD" },
    { rowSpan: 2, label: "PLANTILLA ITEM" },
    { rowSpan: 2, label: "GROSS" },
    { rowSpan: 2, label: "PERA ADA" },
    { rowSpan: 2, label: "IN SERVICE" },
    { rowSpan: 2, label: "DATE" },
    { rowSpan: 2, label: "# OF DAYS 1 MONTH" },
    { rowSpan: 2, label: "HOL/WEEKENDS/OFF" },
    { rowSpan: 2, label: "PRORATED RATE" },
    { rowSpan: 2, label: "PRORATED PERA" },
    { rowSpan: 2, label: "PER DAY" },
    { rowSpan: 2, label: "PER MINUTE " },
    { rowSpan: 2, label: "PER DAY" },
    { rowSpan: 2, label: "PER MINUTE " },
    { colSpan: 2, label: "DEDUCTION" },
    { colSpan: 3, label: "BASIC" },
    { colSpan: 3, label: "PERA ADA" },
    ...(additionalSelectValue !== "Last Salary (Basic)"
      ? [{ rowSpan: 2, label: "GSIS INSURED DAYS" }]
      : []),
    { rowSpan: 2, label: "BASIC EARNED" },
    { rowSpan: 2, label: "PERA ADA EARNED" },
    { rowSpan: 2, label: "TOTAL" },
    ...(contributions.length > 0
      ? [{ colSpan: contributionColSpan + 1, label: "" }]
      : []),
    { rowSpan: 2, label: "NET PAY" },
    { rowSpan: 2, label: "EMAIL" },
  ];

  const subheadersISB = [
    "DAYS",
    "MINS",
    "DAYS",
    "MINS",
    "BASIC",
    "DAYS",
    "MINS",
    "PERA",
    "TAX",
    ...contributions,
  ];

  const headersISAP = [
    { rowSpan: 2, label: "#" },
    { rowSpan: 2, label: "EMPLOYMENT STATUS" },
    { rowSpan: 2, label: "NH STATUS" },
    { rowSpan: 2, label: "CONCAT LIST" },
    { rowSpan: 2, label: "EMPLOYEE CODE" },
    { rowSpan: 2, label: "ACCOUNT NUMBER" },
    { colSpan: 3, label: "" },
    { rowSpan: 2, label: "PLANTILLA POSITION" },
    { rowSpan: 2, label: "COVERAGE PERIOD" },
    { rowSpan: 2, label: "AP RATE" },
    { rowSpan: 2, label: "DAILY RATE" },
    { rowSpan: 2, label: "PER MINUTE" },
    { rowSpan: 2, label: "DAYS EARNED" },
    { rowSpan: 2, label: "NO. OF LATES INCURRED" },
    { rowSpan: 2, label: "LATES/UT DEDUCTION" },
    ...(additionalSelectValue !== "Initial Salary (AP)"
      ? [{ rowSpan: 2, label: "OVERPAYMENT" }]
      : []),
    { rowSpan: 2, label: "EARNED FOR THE PERIOD" },
    { rowSpan: 2, label: "TAX" },
    ...(additionalSelectValue !== "Initial Salary (AP)"
      ? otherDeductionType.length > 0
        ? [
            {
              colSpan: otherDeductionColSpan,
              label: "",
            },
          ]
        : []
      : []),
    { rowSpan: 2, label: "NET PAY" },
    { rowSpan: 2, label: "EMAIL" },
  ];

  const subheadersISAP = ["LN", "FN", "MN"];

  const backwageHeaders = [
    { rowSpan: 2, label: "#" },
    { rowSpan: 2, label: "GROSS" },
    { rowSpan: 2, label: "RATE" },
    { rowSpan: 2, label: "LATES AND ABSENCES" },
    { rowSpan: 2, label: "TOTAL LATES & ABSENCES" },
    { rowSpan: 2, label: "PRO RATED" },
    { rowSpan: 2, label: "CHECKING" },
    { rowSpan: 2, label: "TOTAL GROSS" },
    ...(contributions.length > 0
      ? [{ colSpan: contributionColSpan + 1, label: "" }]
      : []),
    { rowSpan: 2, label: "EARNED FOR THE PERIOD" },
    { rowSpan: 2, label: "EMAIL" },
  ];

  const initialRATAHeaders = [
    { rowSpan: 2, label: "#" },
    {
      rowSpan: 2,
      label: " REPRESENTATION ALLOWANCE / TRANSPORTATION ALLOWANCE  (RATA)",
    },
    {
      rowSpan: 2,
      label: " NUMBER OF WORKDAYS OF ACTUAL WORK PERFORMANCE IN A MONTH ",
    },
    { rowSpan: 2, label: "ACTUAL RATA FOR A MONTH" },
    { rowSpan: 2, label: "NET AMOUNT" },
    { rowSpan: 2, label: "EMAIL" },
  ];

  const initialRATAsubHeaders = [];

  const backwageSubHeaders = ["TAX", ...contributions];

  const salaryDiffHeaders = [
    { rowSpan: 2, label: "#" },
    {
      rowSpan: 2,
      label: "DATE RELEASED/ COMPLETED",
    },
    {
      rowSpan: 2,
      label: " DATE REC",
    },
    { rowSpan: 2, label: "DATE RELEASED" },
    { rowSpan: 2, label: "VOUCHER #" },
    { rowSpan: 2, label: "EMPLOYEE CODE" },
    { rowSpan: 2, label: " CODE" },
    { rowSpan: 2, label: "CONCAT LIST" },
    { rowSpan: 2, label: "ACCOUNT No." },
    { rowSpan: 2, label: "LN" },
    { rowSpan: 2, label: "FN" },
    { rowSpan: 2, label: "MN" },
    { rowSpan: 2, label: "MI" },
    { rowSpan: 2, label: "COVERAGE PERIOD" },
    { rowSpan: 2, label: "OLD ITEM" },
    { rowSpan: 2, label: "OLD RATE" },
    { rowSpan: 2, label: "NEW ITEM " },
    { rowSpan: 2, label: "NEW RATE " },
    { rowSpan: 2, label: "DIFFERENTIAL" },
    { rowSpan: 2, label: " PRORATED MONTH" },
    { rowSpan: 2, label: "IN SERVICE" },
    { rowSpan: 2, label: "DATE" },
    { rowSpan: 2, label: "# OF DAYS 1 MONTH" },
    { rowSpan: 2, label: " PRORATED RATE (1ST MONTH)" },
    { rowSpan: 2, label: "NO. OF WHOLE MOS." },
    { rowSpan: 2, label: " EARNED WHOLE MOS." },
    { rowSpan: 2, label: "TOTAL" },
    { rowSpan: 2, label: "TAX" },
    { rowSpan: 2, label: "total months" },
    { rowSpan: 2, label: "NET PAY" },
    { rowSpan: 2, label: "MY DIFF" },
    { rowSpan: 2, label: "YE DIFF" },
    { rowSpan: 2, label: "TOTAL" },
  ];

  const salaryDiffsubHeaders = [];

  const commonHeaders = [
    { label: "Employee ID" },
    { label: "Account Number" },
    { label: "Last Name" },
    { label: "First Name" },
    { label: "Middle Name" },
    { label: "Basic Rate" },
  ];

  const allowanceHeaders =
    allowanceName === "Gratuity Pay"
      ? [
          { label: "SEQ No." },
          ...commonHeaders,
          ...additionalHeader,
          ...displayHeaderLabel,
          { label: "Net Pay" },
        ]
      : [
          ...commonHeaders,
          ...additionalHeader,
          ...displayHeaderLabel,
          { label: "Net Pay" },
        ];

  switch (true) {
    case payrollType === "J.O Salary" && additionalSelectValue === "Salary":
      // employmentType === "Job Order" &&:
      return [jobOrderBasicPayHeaders, jobOrderBasicPaySubHeaders];
    case payrollType === "Augmentation Pay" &&
      employmentType !== "Job Order" &&
      (additionalSelectValue === "General Payroll" ||
        additionalSelectValue === "Addendum Payroll"):
      return [augmentedPayHeaders, augmentedPaySubHeaders];
    case payrollType === "Basic Pay" &&
      employmentType !== "Job Order" &&
      additionalSelectValue === "General Payroll":
      return [basicPayHeaders, basicPaySubHeaders];
    case additionalSelectValue === allowanceName:
      return [allowanceHeaders, []];
    case payrollType === "Basic Pay" &&
      employmentType !== "Job Order" &&
      additionalSelectValue === "Addendum Payroll":
      return [AddendumPayHeaders, AddendumPaySubHeaders];
    case payrollType === "Basic Pay" &&
      employmentType !== "Job Order" &&
      additionalSelectValue === "Addendum Back-Pay":
      return [backPayHeaders, backPaySubHeaders];
    case payrollType === "J.O Salary" &&
      additionalSelectValue === "Addendum Payroll":
      return [AddendumPayJOHeaders, AddendumPayJOSubHeaders];
    case payrollType === "Addendum Payroll" &&
      additionalSelectValue === "Addendum to Addendum Pay":
      return [AddToAddHeaders, AddToAddSubHeaders];
    case payrollType === "Individual Payroll" &&
      employmentType !== "Job Order" &&
      (additionalSelectValue === "Initial Salary (Basic)" ||
        additionalSelectValue === "Last Salary (Basic)"):
      return [headersISB, subheadersISB];
    case payrollType === "Individual Payroll" &&
      employmentType !== "Job Order" &&
      (additionalSelectValue === "Initial Salary (AP)" ||
        additionalSelectValue === "Last Salary (AP)"):
      return [headersISAP, subheadersISAP];
    case payrollType === "Individual Payroll" &&
      employmentType !== "Job Order" &&
      additionalSelectValue === "Backwage (BASIC)":
      return [backwageHeaders, backwageSubHeaders];
    case payrollType === "Individual Payroll" &&
      employmentType === "Organic" &&
      additionalSelectValue === "Initial RATA":
      return [initialRATAHeaders, initialRATAsubHeaders];
    case payrollType === "Individual Payroll" &&
      employmentType !== "Job Order" &&
      additionalSelectValue === "Salary Differential (Basic)":
      return [salaryDiffHeaders, salaryDiffsubHeaders];
    default:
      return [[], []];
  }
};
